import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceComplete, isResourceLoading } from './common';

const isWebinarsLoading = lruMemoize(isResourceLoading);

const getWebinars = lruMemoize((data) => data.get('webinars', List()));

const getWebinarData = (state) => state.getIn(['app', 'training']);
const isWebinarLoaded = createSelector(getWebinarData, isResourceComplete);
const getWebinarTitle = createSelector(getWebinarData, (data) => data.getIn(['webinar', 'title']));

export {
    isWebinarLoaded,
    isWebinarsLoading,
    getWebinars,
    getWebinarTitle,
};
